import { render, staticRenderFns } from "./basicMedical.vue?vue&type=template&id=514722f5&scoped=true"
import script from "./basicMedical.vue?vue&type=script&lang=js"
export * from "./basicMedical.vue?vue&type=script&lang=js"
import style0 from "./basicMedical.vue?vue&type=style&index=0&id=514722f5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "514722f5",
  null
  
)

export default component.exports